<template>
    <div>
        <div class="clear">
            <self-back :pageHeaderList="[{'name':'角色管理','path':'/roleManage'},{'name':role_name+'权限管理'}]" style="float:left"></self-back>
            <div class="permisssion_hint" style="float:right">
                <i class="el-icon-warning"></i>
                <span>此表为权限表，非开发人员仅可更改权限的开关</span>
            </div>
        </div>
        <div class="content" v-loading='loading' v-if="!smallClass">
            <div class="clear">
                <button class="addRoleButton" v-if="userInfo.role_id == 12" @click="addPermissionEvent">+ 添加大类</button>
            </div>
            <el-table
                class="table"
                :header-cell-style="{background:'#f5f7fa'}"
                :data="permissionList"
                height="calc(100vh - 172px)"
                border
                >
                <el-table-column prop="id" label="ID"  align='center' ></el-table-column>
                <el-table-column prop="title" label="大类标题" align='center' ></el-table-column>
                <el-table-column
                label="权限"
                align='center'
                >
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.is_enable"
                            @change="switchChange(scope.row)"
                            active-color="#5B7BFE"
                            inactive-color="#cccccc"
                            >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="route" label="路由" align='center' ></el-table-column>
                <el-table-column
                align='center'
                label="下级模块"
                >
                    <template slot-scope="scope">
                        <span class="lookUp" v-if="!scope.row.route&&scope.row.is_enable" @click="lookSmallPermission(scope.row)">查看下级</span>
                    </template>
                </el-table-column>
                <el-table-column
                align='center'
                label="页面图标"
                >
                    <template slot-scope="scope">
                        <img :src="scope.row.icon" style="background: #ccc;width: 30px;border-radius: 3px;margin: auto;" alt="">
                    </template>
                </el-table-column>
                <el-table-column
                align='center'
                v-if="userInfo.role_id == 12"
                label="操作">
                    <template slot-scope="scope">
                        <button @click="modifyPromissionEvent(scope.row)">修改</button>
                        <button style="background:#FC726D" @click="deletePermissionFlagEvent(scope.row)">删除</button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 添加权限 -->
        <el-dialog
            :title="isEdit?'修改权限':'添加权限'"
            :visible.sync="addPermissionFlag"
            width="30%"
            :close-on-click-modal='false'
            center>
            <div class="dialogBox">
                <div class="dialogitem" style="margin-bottom: 20px;">
                    <label>大类权限名称：</label>
                    <el-input
                        placeholder="请输入大类权限名称"
                        style="width:60%"
                        v-model.trim="permissionName"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label>页面路由：</label>
                    <el-input
                        placeholder="请输入页面路由"
                        style="width:60%"
                        v-model.trim="permissionRouter"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label>页面图标：</label>
                    <el-input
                        placeholder="请输入页面图标"
                        style="width:60%"
                        v-model.trim="permissionIcon"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem" v-if="!isEdit">
                    <label>是否开启权限：</label>
                    <el-switch
                        v-model="pemission_enable"
                        active-color="#5B7BFE"
                        inactive-color="#cccccc"
                        >
                    </el-switch>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAddRole" size="mini">取 消</el-button>
                <el-button type="primary" @click="addPermissionYes" size="mini">确 定</el-button>
            </span>
        </el-dialog>
        <small-class v-if="smallClass" :smallPermissionData="smallPermissionData" @back="back"></small-class>
    </div>
</template>
<script>
import smallClass from  './smallClass'
export default {
    components:{
        smallClass
    },
    data(){
        return{
            role_id:'',
            loading:false,
            isEdit:false,
            addPermissionFlag:false,
            permissionList:[],
            permissionName:'',
            permissionRouter:'',
            permissionIcon:'',
            pemission_enable:false,
            parent_id:0,
            editData:{},
            role_name:'',
            smallClass:false,
            smallPermissionData:{},
            userInfo:{}
        }
    },
    created(){
        this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
        this.role_id = this.$route.params.role_id;
        this.rolesListEvent();
        this.getPermission()
    },
    methods:{
        lookSmallPermission(data){//查看下级权限页面
            this.smallPermissionData = data;
            this.smallPermissionData.user_role_id = this.role_id;
            this.smallClass = true;
        },
        back(){
            this.smallClass = false;
        },
        rolesListEvent(){
           this.$axios.get(this.URL.BASEURL + this.URL.rolesList,{
               params:{
                   page: 1,
                   page_size: 999
               }
            }).then((res) => {
                var res=res.data;
                if(res&& res.errno == 0){
                    this.role_name = res.rst.data.filter((v)=>{
                        return v.id == this.role_id
                    })[0].name
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
            })
        },
        getPermission(){
            this.addPermissionFlag = false;
            this.loading = true;
            this.$axios.get(this.URL.BASEURL + this.URL.getPermission,{
                params:{
                    role_id: this.role_id,
                    parent_id: this.parent_id
                }
            }).then((res) => {
                var res=res.data;
                this.loading = false
                if(res&& res.errno == 0){
                    this.permissionList = res.rst;
                    this.permissionList.forEach((item) => {
                        item.is_enable = item.enable == 1 ? true : false
                    });
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false;
            })
        },
        addPermissionEvent(){
            this.editData = {};
            this.addPermissionFlag = true;
            this.isEdit = false;
        },
        addPermissionYes(){
            if(this.permissionName == ''){
                this.$message({
                    message: '请输入权限名称',
                    type: 'fail'
                })
                return
            }
            if(this.isEdit){//编辑
                this.$axios.post(this.URL.BASEURL + this.URL.editPermission,{
                    id: this.editData.id,
                    title: this.permissionName,
                    route: this.permissionRouter,
                    icon: this.permissionIcon
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.getPermission()
                        this.cancelAddRole()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }else{
                this.$axios.post(this.URL.BASEURL + this.URL.addPermission,{
                    role_id: this.role_id,
                    parent_id: this.parent_id,
                    title: this.permissionName,
                    route: this.permissionRouter,
                    icon: this.permissionIcon,
                    enable: this.pemission_enable?1:0
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.getPermission()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }
        },
        modifyPromissionEvent(data){
            this.editData = data;
            this.permissionName = data.title;
            this.permissionRouter = data.route;
            this.permissionIcon = data.icon;
            this.pemission_enable = data.enable == 1 ? true : false;
            this.addPermissionFlag = true;
            this.isEdit = true;
        },
        cancelAddRole(){//取消添加角色
            this.isEdit = false;
            this.addPermissionFlag = false;
            this.permissionName = '';
            this.permissionRouter = '';
            this.permissionIcon = '';
            this.pemission_enable = false;
            this.editData = {};
        },
        deletePermissionFlagEvent(data){//删除
            this.$confirm('确定要删除该权限?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post(this.URL.BASEURL + this.URL.delPermission,{
                        id: data.id
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.getPermission()
                        }else {
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                    })
                }).catch(() => {        
            });
        },
        switchChange(data){//修改权限状态
            this.$axios.post(this.URL.BASEURL + this.URL.changePermissionStatus,{
                id: data.id,
                enable: data.enable == 1 ? 0 : 1,
                role_id: this.role_id,
            }).then((res) => {
                var res=res.data;
                if(res&& res.errno == 0){
                    this.getPermission()
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.content{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding: 15px 15px 0;
    .addRoleButton{
        width: 100px;
        height: 30px;
        background: #5B7BFE;
        border-radius: 4px;
        color: #FFFFFF;
        font-size: 13px;
        border:none;
        float: left;
    }
    .table{
        margin-top: 15px;
        button{
            min-width: 60px;
            height: 26px;
            background: #5B7BFE;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 12px;
            border: none;
            padding: 0 6px;
        }
    }
}
.dialogitem{
    margin-bottom: 20px;
    &:last-of-type{
        margin-bottom: 0;
    }
    label{
        display: inline-block;
        width: 100px;
        color: #202652;
        font-size: 14px;
        line-height: 20px;
    }
}
.permisssion_hint{
    font-size: 14px;
    line-height: 20px;
    color: rgb(255,106,0);
    margin-top: 15px;
    margin-right: 30px;
}
.role_title{
    float: left;
    font-size: 14px;
    font-weight: 500;
    color: #202652;
    line-height: 30px;
    margin-right: 30px;
}
.lookUp{
    color: #5c7bfe;
    font-size: 13px;
    cursor: pointer;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/systemManage/permission/index.vue